export default function pushAnalytics(event, data = {}, tree = [], user_logged_status = 'Logged Out') {
  window.__analytics_queue__ = window.__analytics_queue__ || [];

  window.__analytics_queue__.push({
    event,
    data: {
      app: 'tcom sign in',
      content_section: data.content_section || "Sign in",
      ...data,
      user_logged_status,
      _tree: tree
    }
  });
}